import { FC, useContext, useState } from 'react';

import { Button, PasswordInput } from '@smartshell/ui-kit';
import { Controller, useForm } from 'react-hook-form';

import { LocalizationContext } from 'localization';
import { ESettingsAliases, SettingsContext } from 'settings';

import s from './Password.module.scss';

const DEFAULT_VALUES = { password: '' };

export const Password: FC = () => {
  const {
    actions: { setSetting },
  } = useContext(SettingsContext);
  const { t } = useContext(LocalizationContext);

  const {
    control,
    handleSubmit,
    reset,
    formState: { isSubmitting },
  } = useForm({
    defaultValues: DEFAULT_VALUES,
    mode: 'onChange',
  });

  const [isEditMode, setIsEditMode] = useState(false);

  return (
    <form
      className={s['password-container']}
      onSubmit={handleSubmit(({ password }) => {
        if (!password) {
          return setIsEditMode(false);
        }

        return setSetting({
          alias: ESettingsAliases.SHELL_PASSWORD,
          value: password,
        }).then(() => {
          reset(DEFAULT_VALUES);
        });
      })}
    >
      <div className={s.password}>
        <Controller
          control={control}
          name="password"
          render={({ field: { value, onChange }, fieldState: { error } }) => (
            <PasswordInput
              variant="secondary"
              value={value}
              onChange={onChange}
              disabled={isSubmitting || !isEditMode}
              autoComplete="off"
              error={error?.message}
              bordered
            />
          )}
          rules={{
            minLength: {
              value: 8,
              message: t('errors.minLength', 8),
            },
          }}
        />
      </div>
      <Button
        type={isEditMode ? 'submit' : 'button'}
        variant="secondary"
        onClick={(e) => {
          e.stopPropagation();

          if (!isEditMode) {
            setIsEditMode(true);
            e.preventDefault();
          }
        }}
        disabled={isSubmitting}
        iconName={isEditMode ? 'CheckIcon' : 'EditIcon'}
        className={s.btn}
        onlyIcon
      />
    </form>
  );
};
